const ONES = [
  '',
  'One',
  'Two',
  'Three',
  'Four',
  'Five',
  'Six',
  'Seven',
  'Eight',
  'Nine',
  'Ten',
  'Eleven',
  'Twelve',
  'Thirteen',
  'Fourteen',
  'Fifteen',
  'Sixteen',
  'Seventeen',
  'Eighteen',
  'Nineteen',
];

const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

const WESTERN_GROUPS = [
  { value: 1_000_000_000, label: 'Billion' },
  { value: 1_000_000, label: 'Million' },
  { value: 1_000, label: 'Thousand' },
] as const;

function belowThousand(num: number): string {
  const words: string[] = [];
  let n = num;
  if (n >= 100) {
    words.push(`${ONES[Math.floor(n / 100)]} Hundred`);
    n %= 100;
  }
  if (n >= 20) {
    words.push(TENS[Math.floor(n / 10)]);
    n %= 10;
  }
  if (n > 0) words.push(ONES[n]);
  return words.join(' ');
}

/** Western / international numbering: Billion, Million, Thousand (not Lakh/Crore). */
export function numberToWords(value: number): string {
  const whole = Math.floor(Math.abs(value));
  if (whole === 0) return 'Zero';

  let remaining = whole;
  const words: string[] = [];
  for (const group of WESTERN_GROUPS) {
    const part = Math.floor(remaining / group.value);
    if (part > 0) {
      words.push(`${belowThousand(part)} ${group.label}`);
      remaining %= group.value;
    }
  }
  if (remaining > 0) {
    words.push(belowThousand(remaining));
  }
  return words.join(' ');
}

function splitAmountParts(amount: number): { whole: number; fils: number } {
  const n = Number(amount);
  const safe = Number.isFinite(n) ? n : 0;
  const whole = Math.floor(safe);
  const fils = Math.round((safe - whole) * 100);
  return { whole, fils };
}

/** `AED - Three Million One Hundred Fifty Thousand And 00/100 Only` */
export function formatAmountInWords(amount: number, currency: string): string {
  const { whole, fils } = splitAmountParts(amount);
  return `${currency} - ${numberToWords(whole)} And ${fils.toString().padStart(2, '0')}/100 Only`;
}

/** `Three Million One Hundred Fifty Thousand And 50/100 Only` (currency shown separately). */
export function formatAmountInWordsPlain(amount: number): string {
  const { whole, fils } = splitAmountParts(amount);
  const fracPart = fils > 0 ? ` And ${fils}/100` : '';
  return `${numberToWords(whole)}${fracPart} Only`;
}
